export function isLocalhost() {
    return window.location.hostname === "localhost";
}
export function isDev() {
    return window.location.hostname === "dev.sentinelfertigation.com";
}
export function isProd() {
    return window.location.hostname === "sentinelfertigation.com";
}
